/* Keep the cart's own contents out of the cart's upsell rows.
 *
 * The rows render once with the page and only [data-products] is re-rendered when the cart
 * changes, so this cannot be done in Liquid: a server-side skip would delete the card for
 * the whole session, and it could never come back when the shopper removed that item.
 * Hiding live is also what makes the FIRST visible card always something they do not
 * already own — which is the actual point of the request.
 *
 * A row whose every card is hidden collapses, so no heading is left stranded over an empty
 * strip. Dots are re-synced to the number still visible, otherwise the row shows nine dots
 * for three cards.
 */
(function () {
  var busy = false;

  /* NOVEMBER WEEK 1: a Graveyard piece in the bag swaps the row to Graveyard, the other half of the outfit first. */
  function graveyard(handles, titles) {
    var row = document.querySelector('[data-gy-handles]');
    if (!row) return;
    var list = (row.getAttribute('data-gy-handles') || '').split(',');
    var inCart = handles.filter(function (h) { return list.indexOf(h) !== -1; });
    document.documentElement.classList.toggle('nv-gy-cart', inCart.length > 0);
    if (!inCart.length) return;
    var bottoms = /sweats|jeans|jorts|shorts/i, tops = /zip|hoodie|jacket|sweatshirt/i, strip = row.querySelector('[data-upsell-strip]');
    var hasBottom = titles.some(function (t) { return bottoms.test(t); }), hasTop = titles.some(function (t) { return !bottoms.test(t) && tops.test(t); });
    if (!strip || hasBottom === hasTop) return;
    var want = hasBottom ? tops : bottoms;
    [].slice.call(strip.querySelectorAll('[data-upsell-handle]'))
      .filter(function (c) { return want.test(c.getAttribute('data-upsell-title') || ''); })
      .reverse().forEach(function (c) { strip.insertBefore(c, strip.firstChild); });
    strip.scrollLeft = 0;
  }

  function apply(handles) {
    document.querySelectorAll('[data-pholoh-upsell], [data-pholoh-upsell-sale]').forEach(function (row) {
      var cards = row.querySelectorAll('[data-upsell-handle]');
      var visible = 0;
      cards.forEach(function (c) {
        var inCart = handles.indexOf(c.getAttribute('data-upsell-handle')) !== -1;
        c.hidden = inCart;
        c.style.display = inCart ? 'none' : '';
        if (!inCart) visible++;
      });
      row.classList.toggle('is-empty', visible === 0);

      var dots = row.querySelectorAll('[data-upsell-dot]');
      dots.forEach(function (d, i) { d.hidden = i >= visible; });
      var wrap = row.querySelector('[data-upsell-dots]');
      if (wrap) wrap.hidden = visible < 2;
    });
  }

  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [], handles = items.map(function (i) { return i.handle; });
        apply(handles);
        graveyard(handles, items.map(function (i) { return i.product_title || ''; }));
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:build', refresh);
  document.addEventListener('ajaxProduct:added', function () { setTimeout(refresh, 120); });

  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
})();
